import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-crumbs',
  templateUrl: './crumbs.component.html',
  styleUrls: ['./crumbs.component.scss']
})
export class CrumbsComponent implements OnInit {
  @Input() crumbs: string[]=[];
  recipeId: number = 0;

  constructor(
    private activeroute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.recipeId = +this.activeroute.snapshot.paramMap.get('id');
  }

  goTo(url:string){
    if (url) {
      this.router.navigateByUrl(url)
    }
  }
}
